  <!-- 客户损益表 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore">
      <template slot="time1">
        <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
      </template>
    </input-plug>
    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" @selectChange="handleSelectionChange" ref="mytable" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true">
        <template slot="time1">
          <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
        </template>
      </input-plug>
    </exportCompoent>
  </div>
</template>
<script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1,exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "客户损益表", //导出时默认文件名
        apiName: "/admin/v3/tms/report/getCustomerOrderProfitList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "导出",
          method: "exportData",
          permissVal: "aaaaa",
        },
        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "打印",
          method: "printData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "input",
          label: "客户单号",
          field: "customerOrderNumbers",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "业务部门",
          field: "businessDeptId",
          setLabel: "departmentName",
          setValue: "deptId",
          placeholder: "请选择",
          selectOptions: [],
        },
        {
          type: "select",
          label: "客户名称",
          field: "customerId",
          placeholder: "请输入",
          selectOptions: [{ label: "全部", val: "1" }],
        },
      ],

      queryData: {
        businessDeptId: null,
        customerId: null,
        customerOrderNumbers: null,
        waybillNumber: null,
      },

      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "年月",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "业务日期",
          field: "businessDate",
          width: "120", // default：120
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计 default：false
          isSort: true, //表格设置里面是否可以排序 default：false
        },
        {
          name: "业务部门",
          field: "businessDeptName",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "业务员",
          field: "businessName",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "客户名称",
          width: "120",
          field: "customerName",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "客户单号",
          field: "customerOrderNumber",
          sort: 6,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "运单号",
          field: "waybillNumber",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "计费取值",
          field: "totalBillingWeight",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "体积",
          field: "totalVolume",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "开单金额",
          field: "billingAmount",
          sort: 19,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "总运费",
          field: "totalFreight",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "税金",
          field: "taxes",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "基本运费",
          field: "basicFreight",
          sort: 2,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "提货费",
          field: "takeFee",
          sort: 2,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },

        {
          name: "送货费",
          field: "sendFee",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "装卸费",
          field: "unLoadFee",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "保险费",
          field: "insuranceFee",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "其他费用",
          field: "allOtherFee",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "代收货款",
          field: "agentAmount",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "其他收支-应收-运单摊分-合计",
          field: "otherFinanceInAmount",
          width: "260",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "总收入",
          field: "totalInAmount",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "结算方式",
          field: "settlementMethod",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "运单创建人",
          field: "createUserName",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "运单-财务应付-合计",
          field: "waybillFinanceOutAmount",
          width: "260",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "发车单-装卸费-合计",
          field: "dispatchLoadFee",
          width: "260",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "发车单-车费分配-摊分-合计",
          field: "dispatchCarFee",
          width: "260",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "异常单-赔偿金额-合计",
          field: "indemnityAmount",
          width: "260",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "出入库装卸费-合计",
          field: "handleOrderAmount",
          width: "260",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "外发单-费用-合计",
          field: "outgoingTotalAmount",
          width: "260",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "其他收支-应付-运单摊分-合计",
          field: "otherFinanceOutAmount",
          width: "260",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "总支出",
          field: "totalOutAmount",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "客户损益",
          field: "customerProfit",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "利润率",
          field: "profitMargin",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
      ],
      sortName: "客户损益表", //  排序名
      pageGroupName: "CustomPL",
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.GetData();
    this.GetDeptList();
  },
  methods: {
    // 获取客户损益表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.queryData.startBusinessDate = this.startTime_a
        ? this.startTime_a + " 00:00:00"
        : "";
      this.queryData.endBusinessDate = this.endTime_a
        ? this.endTime_a + " 23:59:59"
        : "";
      this.$API.CustomerOrderProfitList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";

          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---客户损益表`);
        }
      });
    },

    // 获取业务部门
    GetDeptList() {
      this.$API.wtl_getDeptList().then((res) => {
        if (res.data.status === "success") {
          this.baseConfig[2].selectOptions = res.data.result?.data || [];
        } else {
          console.log(res.data.message);
        }
      });
    },
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.GetData();
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 导出
    exportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },
    // 表格设置
    SetTable() {},
    // 打印
    printData() {},
  },
};
</script>
        <style scoped lang="less">
</style>
                          